export default function FreelancerPitch({ pitch }) {
  return (
    <p className="h-96 overflow-y-auto">{pitch || "No record to display"}</p>
  );
}
